var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhitepot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0129 17.903H5.71394C2.92425 17.903 1.06445 16.5081 1.06445 13.2535V6.74421C1.06445 3.48957 2.92425 2.09473 5.71394 2.09473H15.0129C17.8026 2.09473 19.6624 3.48957 19.6624 6.74421V13.2535C19.6624 16.5081 17.8026 17.903 15.0129 17.903Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3639 12.7884C11.9046 12.7884 13.1536 11.5394 13.1536 9.99867C13.1536 8.45797 11.9046 7.20898 10.3639 7.20898C8.82321 7.20898 7.57422 8.45797 7.57422 9.99867C7.57422 11.5394 8.82321 12.7884 10.3639 12.7884Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.06445 7.20905H1.99435C4.78404 7.20905 5.71394 6.27916 5.71394 3.48947V2.55957",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6632 7.20905H18.7333C15.9436 7.20905 15.0137 6.27916 15.0137 3.48947V2.55957",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.06445 12.7891H1.99435C4.78404 12.7891 5.71394 13.719 5.71394 16.5086V17.4385",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6632 12.7891H18.7333C15.9436 12.7891 15.0137 13.719 15.0137 16.5086V17.4385",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitepot);
export default __webpack_public_path__ + "static/media/whitepot.45422a698058a393e1f84ca95dc245d2.svg";
export { ForwardRef as ReactComponent };